import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "onl4-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Онлайн бронирование недоступно!", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_selector = _resolveComponent("date-selector")!
  const _component_main_selector = _resolveComponent("main-selector")!
  const _component_q_step = _resolveComponent("q-step")!
  const _component_guest_info = _resolveComponent("guest-info")!
  const _component_payment_type_selector = _resolveComponent("payment-type-selector")!
  const _component_q_stepper = _resolveComponent("q-stepper")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_wait_payment_dialog = _resolveComponent("wait-payment-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.division && _ctx.baseURL && _ctx.APIKey)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (Object.keys(_ctx.config).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_date_selector),
                (!_ctx.isWidgetMode && _ctx.step != -1)
                  ? (_openBlock(), _createBlock(_component_q_stepper, {
                      key: 0,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => (_ctx.log('update'))),
                        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event))
                      ],
                      onTransition: _cache[1] || (_cache[1] = ($event: any) => (_ctx.log('transition'))),
                      style: _normalizeStyle({ 'background-color': _ctx.bg }),
                      "header-nav": "",
                      modelValue: _ctx.step,
                      ref: "stepper",
                      color: "primary",
                      class: "q-pa-sm",
                      animated: "",
                      vertical: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room, idx) => {
                          return (_openBlock(), _createBlock(_component_q_step, {
                            key: idx,
                            name: idx,
                            title: 
              'Номер ' +
              (idx + 1) +
              (room.selectedRoom ? ' : ' + room.selectedRoom.description : '')
            ,
                            icon: "mdi-bed-king",
                            "active-icon": "mdi-bed-king",
                            done: room.addRoomResult ? true : false,
                            "header-nav": true
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_main_selector)
                            ]),
                            _: 2
                          }, 1032, ["name", "title", "done"]))
                        }), 128)),
                        _createVNode(_component_q_step, {
                          name: _ctx.rooms.length,
                          title: 'Данные гостей',
                          icon: "mdi-bed-king",
                          "active-icon": "mdi-bed-king",
                          done: _ctx.step > _ctx.rooms.length,
                          "header-nav": _ctx.step >= _ctx.rooms.length
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_guest_info)
                          ]),
                          _: 1
                        }, 8, ["name", "done", "header-nav"]),
                        _createVNode(_component_q_step, {
                          name: _ctx.rooms.length + 1,
                          title: 'Оплата',
                          icon: "mdi-bed-king",
                          "active-icon": "mdi-bed-king",
                          "header-nav": false
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_payment_type_selector)
                          ]),
                          _: 1
                        }, 8, ["name"])
                      ]),
                      _: 1
                    }, 8, ["style", "modelValue"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_q_banner, {
            style: {"margin-bottom":"20px"},
            class: "bg-red text-white text-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_5,
                _hoisted_6,
                (!_ctx.baseURL)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Не инициализирован window.onlBaseURL!"))
                  : _createCommentVNode("", true),
                (!_ctx.division)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Не инициализирован window.onlDivision!"))
                  : _createCommentVNode("", true),
                (!_ctx.APIKey)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Не инициализирован window.onlAPIKey!"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])),
    _createVNode(_component_wait_payment_dialog)
  ]))
}